import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import QuickOrderAutoComplete from './QuickOrderAutoComplete';
import StockStatusTag from '../StockStatusTag';
import QuantityInputField from '../QuantityInputField';

const QuickOrderDesktopTable = (props) => {
  const {
    rows,
    showNameAutoComplete,
    onTabClick,
    onAutoCompleteItemSelected,
    clearRow,
    queryResult,
    isLoading,
    onArticleNumblerBlur,
    onQuantityInputChange,
    onNameInputChange,
    onNoteInputChange,
    onArticleNumblerChange,
  } = props;
  const [currentRow, setCurrentRow] = useState();

  return (
    <>
      <table className="quick-order-table">
        <thead>
          <tr>
            <th className="text-medium color-grey-900 bold">
              {translate('quickorder.articlenumber')}
            </th>
            <th className="text-medium color-grey-900 bold">
              {translate('quickorder.name')}
            </th>
            <th className="text-medium color-grey-900 bold">
              {translate('quickorder.note')}
            </th>
            <th className="text-medium color-grey-900 bold">
              {translate('quickorder.inventory')}
            </th>
            <th className="text-medium color-grey-900 bold">
              {translate('quickorder.price')}
            </th>
            <th className="text-medium color-grey-900 bold">
              {translate('quickorder.quantity')}
            </th>
            <th className="text-medium color-grey-900 bold">
              {translate('quickorder.totalamount')}
            </th>
            <th className="text-medium color-grey-900 bold"></th>
          </tr>
        </thead>
        <tbody className="quick-order-table__rows">
          {rows?.map((row, index) => {
            return (
              <tr
                className={`quick-order-table__row ${
                  row.articleNumber &&
                  row.name &&
                  'quick-order-table__row--filled'
                }`}
                key={'row' + index}
              >
                <td className="quick-order-table__row-input">
                  <input
                    placeholder={translate(
                      'quickorder.placeholder.articlenumber'
                    )}
                    type="text"
                    className="table-input"
                    value={row.articleNumber ?? ''}
                    onFocus={(e) => setCurrentRow(index)}
                    onKeyDown={(e) =>
                      (e.key == 'Tab' || e.key == 'Enter') && onTabClick(index)
                    }
                    onChange={(e) =>
                      onArticleNumblerChange(
                        index,
                        'articleNumber',
                        e.target.value
                      )
                    }
                    onBlur={(e) => onArticleNumblerBlur(index, e.target.value)}
                  />
                </td>
                <td className="auto-fill-container">
                  <input
                    placeholder={translate('quickorder.placeholder.name')}
                    className="table-input"
                    type="text"
                    value={row.name && row.name != null ? row.name : ''}
                    onFocus={(e) => setCurrentRow(index)}
                    onKeyDown={(e) =>
                      (e.key == 'Tab' || e.key == 'Enter') && onTabClick(index)
                    }
                    onChange={(e) =>
                      onNameInputChange(index, 'name', e.target.value)
                    }
                  />
                  {currentRow == index && showNameAutoComplete && (
                    <QuickOrderAutoComplete
                      isLoading={isLoading}
                      queryResult={queryResult}
                      onItemSelected={(item) =>
                        onAutoCompleteItemSelected(item, index)
                      }
                    />
                  )}
                </td>
                <td>
                  {row.articleNumber && row.name && (
                    <input
                      placeholder={translate('quickorder.placeholder.note')}
                      type="text"
                      className="table-input"
                      value={row.note && row.note != null ? row.note : ''}
                      onKeyDown={(e) =>
                        (e.key == 'Tab' || e.key == 'Enter') &&
                        onTabClick(index)
                      }
                      onChange={(e) =>
                        onNoteInputChange(index, 'note', e.target.value)
                      }
                    />
                  )}
                </td>
                <td>
                  {row.articleNumber && row.name && (
                    <StockStatusTag
                      isInStock={row.inStock}
                      description={row.stockStatusDescription}
                      stockStatusType={row.stockStatusType}
                    />
                  )}
                </td>
                <td>
                  {row.articleNumber &&
                    row.name &&
                    row.formattedPrice &&
                    row.formattedPrice}
                </td>
                <td>
                  {row.articleNumber && row.name && (
                    <QuantityInputField
                      quantity={row.quantity}
                      onQuantityChange={(q) =>
                        onQuantityInputChange(index, parseInt(q))
                      }
                    />
                  )}
                </td>
                <td>
                  {row.articleNumber &&
                    row.name &&
                    row.formattedTotalPrice &&
                    row.formattedTotalPrice}
                </td>
                <td>
                  {row.articleNumber && row.name && (
                    <div className="quick-order-table__remove">
                      <i
                        className="[ quick-order-table__remove--btn ] [ ph-trash color-error-700 ]"
                        onClick={() => clearRow(index)}
                        title={translate('general.remove')}
                      />
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default QuickOrderDesktopTable;
